import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
} from 'intact';
import {Sender, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['header'] = function($super) {
                        return (
                            _$ce(2, 'div', (
                                _$cc(Button, {
                                    'ev-click': this.handleNewChat,
                                    'size': 'small',
                                    'children': '+ 开启新对话'
                                })
                            ), 2, 'sender-demo-header')
                        );
                    }),
                    (__$blocks['header'] = function($super, data) {
                        var block = $blocks['header'];
                        var callBlock = function() {
                            return _$blocks['header'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['footer'] = function($super) {
                        return (
                            _$ce(2, 'div', 'AI生成，仅供参考。', 16, 'sender-demo-footer')
                        );
                    }),
                    (__$blocks['footer'] = function($super, data) {
                        var block = $blocks['footer'];
                        var callBlock = function() {
                            return _$blocks['footer'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em),
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};